import { limboBetStore } from '../limboStore/betStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { autoBetStore } from '../../../store/autoBetStore';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { DEFAULT_MULTIPLIER_VALUE, LimboSoundsName } from '../limboCore/constants';
import { liveUpdateStore } from '../../../store/liveUpdateStore';
import { THIS_GAMES_COLUMN_ID } from '../../../core/constants/liveBetsContants';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

let autoBetTimeOutId = null;

class LimboGameService {
  onGetInitialStateResult({ lastSpinInfo }) {
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult({
        resultOdd: lastSpinInfo.resultOdd,
        id: lastSpinInfo.id,
      });
    }
    limboBetStore.setMultiplier(DEFAULT_MULTIPLIER_VALUE);
    // userInfoStore.setBetAmount(parseNumberByPrecision(quickBets[0], 2, userInfoStore.precision));
    liveUpdateStore.setSelectedColumn(THIS_GAMES_COLUMN_ID);
  }

  doSpin() {
    if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (limboBetStore.isBetsClosed) {
      return;
    }
    const model = {
      spinData: {
        betOdd: limboBetStore.multiplier,
      },
      isAutoplay: autoBetStore.isAutoBetOn,
    };
    soundService.play(LimboSoundsName.bet);
    limboBetStore.setIsBetsClosed(true);
    mainGameConnection.doSpin(model);
  }

  handleDoSpinResult({
    result,
    winAmount,
    hash,
    salt,
    key,
    newHash,
    id,
    responseCode,
    odd,
    balance,
  }) {
    if (responseCode === ValidationType.Success) {
      const { resultOdd } = result;
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }
      limboBetStore.setRoundIsWin(null);
      limboBetStore.setGameResult(null);
      limboBetStore.updateResultOdd({
        odd: resultOdd,
        resultModel: { resultOdd, isWin: Boolean(winAmount) },
        key,
        salt,
        hash,
        newHash,
        id,
        winAmount,
        winOdd: odd,
      });

      if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
        autoBetTimeOutId = setTimeout(
          () => {
            this.doSpin();
          },
          userSettingsStore.isTurboOn ? 500 : 1500
        );
      } else {
        this.resetAutoBetState();
      }
    } else {
      notificationStore.setNotification(responseCode);
      limboBetStore.setIsBetsClosed(false);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  resetAutoBetState() {
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 1500);
    }
  }

  clearAutoBetTimeOut() {
    clearTimeout(autoBetTimeOutId);
  }
}

export const limboGameService = new LimboGameService();
